import React, { Fragment, useRef, useState, useEffect, useMemo } from "react"
import propTypes from "prop-types"
//ICONS
import ArrowDownIcon from "assets/customIcons/ArrowDownIcon.svg"
import ArrowUpIcon from "assets/customIcons/ArrowUpIcon.svg"
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import i18n from "i18n"

//CONTEXT & HOOKS
import { useBudget2023Context } from "context/budget2023/Budget2023Context"
import { useAuthContext } from "context/auth/authContext"
import { useDecimalFormatter } from "hooks/useDecimalFormatter"
import { TOTALS } from "constants/decimals"

import useBudgetConfig, {
  BUDGET_CONFIG_TYPES,
} from "hooks/budgeting/useBudgetConfig"

//COMPONENTS
import TablaPartida from "./TablaPartida/index"
import EmptyChapterActions from "./EmptyChapterActions"

//FUNCTIONS
import { currencyFormatDE } from "lib/transformers"
import { useParams } from "react-router-dom"
import {
  getChapterParentId2,
  getPartidasForSearchDisplay,
  getSubcapitulosForSearchDisplay,
  isChapterVisibleInSearch,
  getChapterCheckState,
} from "utils/budgetUtils"
import { Box, Button, Checkbox, CircularProgress } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"

import { getCurrency } from "utils/functions"
import MovePartsToSubchapterModal from "./modals/MovePartsToSubchapterModal"

const NewCapitulo = ({
  imTemplate,
  capitulo,
  indice,
  desplazamiento,
  numeroClases,
  numeroIndex,
  lengthSubCap,
  soyMargen,
  isChecked2,
  setIsChecked2,
  soyFinal,
  projectInfo,
  modificado,
  setClose,
  modificarMargen,
  setModificarMargen,
  ocultoFinal,
  setOcultoFinal,
  isChecked,
  setIsChecked,
  adjustWidth,
  priceWidth,
  status,
  version,
  certificaciones,
  setOpenModalCreatePartida,
  openModalCreatePartida,
  budgetSearchQuery = "",
}) => {
  const {
    updateIsExpanded,
    addCapituloV2,
    updateCapitulov2,
    isBudgetClosed,
    getSubCapitulosContent,
    moveChaptersWithArrows,
    isUpdates,
    changeSidebar,
    checkMultipleChapters,
    budgetTree,
    imChecked2,
    updateChaptersList,
    checkCapitulos,
    chaptersChecked,
    partsChecked,
  } = useBudget2023Context()

  const [capituloData, setCapituloData] = useState({ ...capitulo })
  const [budgetConfig] = useBudgetConfig()
  const preferencias = budgetConfig[BUDGET_CONFIG_TYPES.PREFERENCES]

  const { projectId } = useParams()
  const { user, freeTrialExpired, openFreeTrialExpire } = useAuthContext()

  const { getDecimals } = useDecimalFormatter()

  const budgetSearchTrimmed = budgetSearchQuery.trim()
  const partidasToRender = useMemo(
    () => getPartidasForSearchDisplay(capitulo, budgetSearchTrimmed),
    [capitulo.partidas, budgetSearchTrimmed],
  )
  const subcapitulosToRender = useMemo(
    () => getSubcapitulosForSearchDisplay(capitulo, budgetSearchTrimmed),
    [capitulo.subcapitulos, budgetSearchTrimmed],
  )

  useEffect(() => {
    if (
      budgetSearchTrimmed &&
      isChapterVisibleInSearch(capitulo, budgetSearchTrimmed)
    ) {
      setRender(true)
    }
  }, [budgetSearchTrimmed, capitulo])

  useEffect(() => {
    setIsChecked2(imChecked2)
  }, [imChecked2])
  useEffect(() => {
    setCapituloData({
      ...capitulo,
    })

    isUpdates()
  }, [capitulo.capituloInfo])

  const { name } = capituloData
  const [render, setRender] = useState(capitulo.isExpanded ? true : false)
  const pixelesDesp2 = desplazamiento / 3 + "px"
  const [contadorActualizaciones, setContadorActualizaciones] = useState(0)
  const [openMovePartsToSubchapter, setOpenMovePartsToSubchapter] =
    useState(false)

  const refDivPrecio = useRef(null)
  const onChangeName = e => {
    setCapituloData({
      ...capituloData,
      name: e.target.value,
    })
    capitulo.name = e.target.value
    capitulo.capituloInfo.name = e.target.value
  }
  const changeCheck = e => {
    if (e.nativeEvent.shiftKey) {
      if (capitulo.checked === true) {
        checkCapitulos(capitulo.chapterId, false)
        updateChaptersList(capitulo.capituloInfo)
      } else {
        checkMultipleChapters(capitulo.chapterId)
      }
    } else {
      if (capitulo.checked === true) {
        checkCapitulos(capitulo.chapterId, false)
        updateChaptersList(capitulo.capituloInfo)
      } else {
        checkCapitulos(capitulo.chapterId, true)
        updateChaptersList(capitulo.capituloInfo)
      }
    }
  }

  const createPar1 = () => {
    setOpenModalCreatePartida(true, capitulo.chapterId)
  }

  const addsubCapitulo2 = async () => {
    //se llama desde el capitulo hijo por lo que para la posicion es necesario saber los subcapitulos del padre
    let parent = await getChapterParentId2(
      capituloData.parentId,
      budgetTree.subcapitulos,
      false,
      0,
      {},
    )
    addCapituloV2(
      {
        ...capituloData,
        clientPrice: 0,
        name: "",
        price: 0,
        tags: [],
        subcapitulos: [],
        parentId: capituloData.parentId,
        partidas: [],
        position: parent.subcapitulos.length,
        sended: "false",
        selfManagement: "false",
        root: "false",
      },
      indice,
    )
  }
  const addsubCapitulo3 = () => {
    addCapituloV2(
      {
        ...capituloData,
        clientPrice: 0,
        name: "",
        price: 0,
        tags: [],
        subcapitulos: [],
        parentId: capituloData.chapterId,
        partidas: capituloData.partidas,
        position: capituloData.subcapitulos.length,
        sended: "false",
        selfManagement: "false",
        root: "false",
      },
      indice,
    )
  }

  const [cargado, setCargado] = useState(
    capitulo.subcapitulos.length > 0 || capitulo.partidas.length > 0
      ? true
      : false,
  )
  const [loadingCap, setLoadingCap] = useState(false)
  const handleCapitulo = async () => {
    if (!e) var e = window.event
    e.cancelBubble = true
    if (e.stopPropagation) e.stopPropagation()
    if (capitulo.isExpanded == true) {
      setRender(false)
    } else {
      setRender(true)
      if (cargado == false) {
        setLoadingCap(true)
        setLoadingCap(false)
        setCargado(true)
      }
    }
    updateIsExpanded(capitulo.capituloInfo.chapterId)
  }

  const handleUpdate = () => {
    updateCapitulov2(capituloData)
  }

  const [alinearPrecio, setAlineacion] = useState(false)

  useEffect(() => {
    if (modificarMargen == true) {
      setAlineacion(true)
    }
  }, [modificarMargen, capitulo.isExpanded])

  const getCertPrevious = () => {
    if (certificaciones) {
      return `Cert. Previa ${currencyFormatDE(
        capitulo.totalCertPreviousChapter
          ? capitulo.totalCertPreviousChapter
          : 0,
        getCurrency(user["custom:currency"]),
        getDecimals(TOTALS),
      )}`
    }

    return `Coste Obj. ${currencyFormatDE(
      capitulo.price,
      getCurrency(user["custom:currency"]),
      getDecimals(TOTALS),
    )}`
  }

  const getChapterProperty = property => {
    return currencyFormatDE(
      capitulo[property] ? capitulo[property] : 0,
      getCurrency(user["custom:currency"]),
      getDecimals(TOTALS),
    )
  }

  const getCertCurrent = () => {
    if (certificaciones) {
      return `Cert. Actual ${currencyFormatDE(
        capitulo.totalCertCurrentChapter ? capitulo.totalCertCurrentChapter : 0,
        getCurrency(user["custom:currency"]),
        getDecimals(TOTALS),
      )}`
    }

    return `Comercial ${currencyFormatDE(
      preferencias.descuento
        ? capitulo.clientPrice
        : capitulo.clientPriceWithoutDiscount,
      getCurrency(user["custom:currency"]),
      getDecimals(TOTALS),
    )}`
  }

  const checkState = getChapterCheckState(capitulo)
  const hasSelection = chaptersChecked.length > 0 || partsChecked.length > 0

  return (
    <Fragment>
      {capitulo ? (
        capitulo.parentId == "root" ||
        capitulo.capituloInfo.parentId == "root" ? (
          <Fragment>
            <div
              id="NewCapi"
              data-testid="capitulo-row"
              onClick={e => {
                handleCapitulo(e)
              }}
              className={numeroClases}
              style={{
                display: "",
                backgroundColor: capitulo.isExpanded
                  ? imTemplate
                    ? "#FFd52B"
                    : "#CCD8FC"
                  : "white",
                visibility: "inherit",
                borderBottom: "0px",
                paddingLeft: "14px",
                marginLeft: "0px",
                marginTop: "9px",
                border:
                  capitulo.checked &&
                  (imTemplate ? "1px solid #ffe992" : "1.5px solid #4461D7"),
                borderRadius: capitulo.isExpanded ? "6px 6px 0px 0px" : "6px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                width="100%"
                style={{
                  marginTop: "0px",
                  marginLeft: "0px",
                  paddingRight: "16px",
                }}
              >
                <Box
                  style={{
                    width: "23px",
                    minWidth: "23px",
                    marginTop: "2px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {loadingCap ? (
                    <CircularProgress
                      style={{
                        width: "18px",
                        height: "20px",
                        color: "#414141",
                        marginRight: "4px",
                        marginTop: "0px",
                        display: "block",
                      }}
                    />
                  ) : capitulo.isExpanded ? (
                    <KeyboardArrowDownIcon
                      style={{ cursor: "pointer" }}
                      className="dropdownArrowB"
                      data-testid="capitulo-toggle-expand"
                    />
                  ) : (
                    <KeyboardArrowRightIcon
                      style={{ cursor: "pointer" }}
                      className="dropdownArrowB"
                      data-testid="capitulo-toggle-expand"
                    />
                  )}
                </Box>

                <div className={capitulo.checked ? " " : "detallesCap"}>
                  <div className="tdcheckColumn">
                    {!certificaciones && (
                      <Checkbox
                        checked={checkState === "all"}
                        indeterminate={checkState === "some"}
                        onClick={e => {
                          if (!e) var e = window.event
                          e.cancelBubble = true
                          if (e.stopPropagation) e.stopPropagation()
                        }}
                        onChange={changeCheck}
                        color="primary"
                        size="small"
                        style={{
                          padding: "0px",
                          cursor: "pointer",
                          zIndex: "5",
                        }}
                      />
                    )}
                  </div>
                </div>

                <div
                  id="NumCapitulo"
                  style={{
                    minWidth: "37px",
                    marginTop: "2px",
                    marginRight: "0px",
                  }}
                >
                  {numeroIndex}.
                </div>

                <Box
                  className="tdCapitulo"
                  style={{
                    flex: 1,
                    minWidth: "220px",
                    overflow: "hidden",
                    marginRight: "8px",
                  }}
                >
                  <input
                    onChange={onChangeName}
                    onClick={e => {
                      ;(e.preventDefault(), e.stopPropagation())
                    }}
                    onDoubleClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      e.target.select()
                    }}
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                        e.preventDefault()
                        e.target.blur()
                        handleUpdate()
                      }
                    }}
                    onBlur={handleUpdate}
                    className="NombreAlign"
                    name={"name"}
                    value={name}
                    data-testid={`budget-chapter-name-input-${capitulo.chapterId}`}
                    style={{
                      fontWeight: "700",
                      width: "100%",
                      maxWidth: "100%",
                      minWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    placeholder={i18n.t("Introduce el nombre del capítulo")}
                    autoComplete="off"
                    disabled={
                      projectInfo.status === "CLOSED" ||
                      version ||
                      certificaciones
                        ? true
                        : user
                          ? freeTrialExpired || user["custom:role"] === "WORKER"
                            ? true
                            : false
                          : true
                    }
                  ></input>
                </Box>

                <Box
                  ref={refDivPrecio}
                  display="flex"
                  alignItems="center"
                  style={{
                    marginLeft: "auto",
                    gap: "8px",
                    flexShrink: 0,
                  }}
                >
                  {capitulo.warning == true ? (
                    <ReportProblemOutlinedIcon style={{ color: "#BF2929" }} />
                  ) : null}

                  <Box className="detallesCap" style={{ minWidth: "42px" }}>
                    <Box
                      style={{
                        backgroundColor: "transparent",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      {budgetTree.subcapitulos.length ==
                      1 ? null : projectInfo.status === "CLOSED" ||
                        version ||
                        certificaciones ||
                        hasSelection ? null : user ? (
                        user.freeTrialExpired ||
                        user["custom:role"] === "WORKER" ? null : (
                          <>
                            {lengthSubCap != capitulo.position + 1 && (
                              <img
                                src={ArrowDownIcon}
                                onClick={e => {
                                  e.stopPropagation()
                                  moveChaptersWithArrows(
                                    projectId,
                                    capitulo,
                                    "down",
                                  )
                                }}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginTop: "2px",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                            {indice > 0 && (
                              <img
                                src={ArrowUpIcon}
                                onClick={e => {
                                  e.stopPropagation()
                                  moveChaptersWithArrows(
                                    projectId,
                                    capitulo,
                                    "up",
                                  )
                                }}
                                style={{
                                  width: "13px",
                                  height: "13px",
                                  marginTop: "2px",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </>
                        )
                      ) : null}
                    </Box>
                  </Box>

                  {(preferencias.precioCoste || certificaciones) && (
                    <div
                      style={{
                        fontFamily: "Helvetica",
                        fontWeight: "700",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        backgroundColor: "#616161",
                        color: "white",
                        borderColor: "#616161",
                        whiteSpace: "nowrap",
                      }}
                      id="precioTotal"
                    >
                      {getCertPrevious()}
                    </div>
                  )}
                  {preferencias.costReal && !certificaciones && (
                    <div
                      name="costReal"
                      style={{
                        minWidth: "20px",
                        fontFamily: "Helvetica",
                        fontWeight: "700",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        backgroundColor: "#414141",
                        color: "white",
                        borderColor: "#414141",
                        whiteSpace: "nowrap",
                      }}
                      id="precioTotal"
                    >
                      Coste Real {getChapterProperty("costReal")}
                    </div>
                  )}
                  {(preferencias.descuento || preferencias.clientPrice) && (
                    <div
                      id="precioTotal"
                      style={{
                        fontWeight: "700",
                        backgroundColor: "white",
                        color: "#414141",
                        border: "1px solid #414141",
                        fontFamily: "Helvetica",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {getCertCurrent()}
                    </div>
                  )}
                </Box>
              </Box>
            </div>
            <div
              style={{
                display: render ? "block" : "none",
                width: "100%",
                backgroundColor: "white",
                border: capitulo.parentId == "root" ? "" : "1px solid #F5F5F5",
                borderRadius: capitulo.isExpanded ? "6px 6px 0px 0px" : "6px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              {render ? (
                partidasToRender.length > 0 ? (
                  <TablaPartida
                    certificaciones={certificaciones}
                    capitulo={capitulo}
                    partidasToRender={partidasToRender}
                    budgetSearchFilterActive={!!budgetSearchTrimmed}
                    numeroIndex={numeroIndex}
                    desplazamiento={desplazamiento + 60}
                    esUnico={true}
                    soyFinal={soyFinal}
                    projectInfo={projectInfo}
                    contadorActualizaciones={contadorActualizaciones}
                    setContadorActualizaciones={setContadorActualizaciones}
                    alinearPrecio={alinearPrecio}
                    ocultoFinal={ocultoFinal}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    version={version}
                    openModalCreatePartida={openModalCreatePartida}
                    setOpenModalCreatePartida={(isOpen, chapterId) =>
                      setOpenModalCreatePartida(isOpen, chapterId)
                    }
                  />
                ) : capitulo.subcapitulos.length === 0 &&
                  (capitulo.partidas || []).length === 0 ? (
                  projectInfo.status === "CLOSED" ||
                  version ||
                  certificaciones ? null : user ? (
                    user.freeTrialExpired ||
                    user["custom:role"] === "WORKER" ? null : (
                      <div
                        className={numeroClases}
                        style={{
                          paddingLeft: "20px",
                          marginLeft: "0px",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "0px",
                            marginLeft: "0px",
                          }}
                        >
                          <div className="tdCapitulo" style={{ zIndex: "2" }}>
                            <EmptyChapterActions
                              chapterId={capitulo.chapterId}
                              onCreatePart={createPar1}
                              testId={`budget-chapter-add-partida-button-${capitulo.chapterId}`}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  ) : null
                ) : null
              ) : null}
              {render ? (
                subcapitulosToRender.length > 0 ? (
                  subcapitulosToRender.map((elemento, index) => (
                    <>
                      {" "}
                      <NewCapitulo
                        imTemplate={imTemplate}
                        key={`from_NewCapitulo_${elemento.chapterId ?? index}`}
                        numeroIndex={numeroIndex + "." + (index + 1)}
                        indice={index}
                        capitulo={elemento}
                        desplazamiento={desplazamiento + 60}
                        numeroClases={numeroClases + 1}
                        lengthSubCap={subcapitulosToRender.length}
                        soyMargen={true}
                        soyFinal={soyFinal}
                        projectInfo={projectInfo}
                        modificado={modificado}
                        setClose={setClose}
                        modificarMargen={modificarMargen}
                        setModificarMargen={setModificarMargen}
                        ocultoFinal={ocultoFinal}
                        isChecked={isChecked}
                        setIsChecked={setIsChecked}
                        setOcultoFinal={setOcultoFinal}
                        certificaciones={certificaciones}
                        adjustWidth={capitulo.parentId == "root" ? true : false}
                        priceWidth={priceWidth + 0.5}
                        version={version}
                        isChecked2={isChecked2}
                        setIsChecked2={setIsChecked2}
                        budgetSearchQuery={budgetSearchQuery}
                        openModalCreatePartida={openModalCreatePartida}
                        setOpenModalCreatePartida={setOpenModalCreatePartida}
                      />
                    </>
                  ))
                ) : budgetSearchTrimmed &&
                  capitulo.subcapitulos.length > 0 &&
                  subcapitulosToRender.length ===
                    0 ? null : projectInfo.status === "CLOSED" ||
                  version ||
                  isBudgetClosed ||
                  certificaciones ? null : user ? (
                  user.freeTrialExpired ||
                  user["custom:role"] === "WORKER" ? null : (
                    <div
                      id=""
                      className={numeroClases}
                      style={{
                        paddingLeft: "20px",
                        marginLeft: "0px",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "0px",
                          marginLeft: "0px",
                        }}
                      >
                        <div style={{ minWidth: "30px" }}></div>
                        <div className="tdCapitulo" style={{ zIndex: "2" }}>
                          <div
                            className="NombreAlign"
                            onClick={() => {
                              freeTrialExpired
                                ? openFreeTrialExpire()
                                : capitulo.partidas &&
                                    capitulo.partidas.length > 0
                                  ? setOpenMovePartsToSubchapter(true)
                                  : addsubCapitulo3()
                            }}
                            data-amplify-analytics-on="click"
                            data-amplify-analytics-name="ChapterCreated"
                            data-amplify-analytics-attrs=""
                            style={{ padding: "10px" }}
                          >
                            {!isBudgetClosed &&
                              (capitulo.partidas &&
                              capitulo.partidas.length > 0 ? (
                                <Button
                                  size="small"
                                  color="secondary"
                                  startIcon={<AddIcon fontSize="small" />}
                                  sx={{ marginBottom: "10px" }}
                                >
                                  {i18n.t("Mover partidas a subcapítulo")}
                                </Button>
                              ) : (
                                <Button
                                  size="small"
                                  color="secondary"
                                  startIcon={<AddIcon fontSize="small" />}
                                  sx={{ marginBottom: "10px" }}
                                >
                                  {i18n.t("Nuevo subcapítulo")}
                                </Button>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ) : null
              ) : null}
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="inline">
              <div
                id="NewSubCapi"
                data-testid="capitulo-row"
                onClick={e => {
                  handleCapitulo(e)
                }}
                className={numeroClases}
                style={{
                  display: "",
                  visibility: "inherit",
                  backgroundColor: capitulo.isExpanded
                    ? imTemplate
                      ? "rgb(252, 213, 107)"
                      : "#CCD8FC"
                    : "#BDD9F7",
                  borderBottom: "0px",
                  paddingLeft: "16px",
                  borderLeft: adjustWidth == true ? "6px solid #93AEFF" : "",
                  marginLeft: "8px",
                  border:
                    capitulo.checked &&
                    (imTemplate ? "1px solid #ffe992" : "1.5px solid #4461D7"),
                }}
              >
                <Box
                  onClick={e => {
                    if (!e) var e = window.event
                    e.cancelBubble = true
                  }}
                  display="flex"
                  alignItems="center"
                  width="100%"
                  style={{
                    cursor: "pointer",
                    visibility: "inherit",
                    borderBottom: "0px",
                    paddingRight: "16px",
                    gap: "8px",
                  }}
                >
                  <Box
                    style={{
                      width: "23px",
                      minWidth: "23px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {loadingCap ? (
                      <CircularProgress
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#414141",
                          marginRight: "4px",
                          marginTop: "0px",
                          display: "block",
                        }}
                      />
                    ) : capitulo.isExpanded ? (
                      <KeyboardArrowDownIcon
                        style={{ cursor: "pointer" }}
                        className="dropdownArrowB"
                        data-testid="capitulo-toggle-expand"
                      />
                    ) : (
                      <KeyboardArrowRightIcon
                        style={{ cursor: "pointer" }}
                        className="dropdownArrowB"
                        data-testid="capitulo-toggle-expand"
                      />
                    )}
                  </Box>

                  <div className={capitulo.checked ? " " : "detallesCap"}>
                    <div className="tdcheckColumn">
                      {!certificaciones && (
                        <Checkbox
                          onChange={changeCheck}
                          onClick={e => {
                            if (!e) var e = window.event
                            e.cancelBubble = true
                            if (e.stopPropagation) e.stopPropagation()
                          }}
                          checked={checkState === "all"}
                          indeterminate={checkState === "some"}
                          color="primary"
                          size="small"
                          style={{
                            padding: "0px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div id="NumCapitulo" style={{ minWidth: "37px" }}>
                    {numeroIndex}
                  </div>

                  <Box
                    style={{
                      flex: 1,
                      minWidth: "220px",
                      overflow: "hidden",
                      marginRight: "8px",
                    }}
                  >
                    <input
                      onChange={onChangeName}
                      onBlur={handleUpdate}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      onDoubleClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        e.target.select()
                      }}
                      className="NombreAlign"
                      name={"name"}
                      data-testid={`budget-chapter-name-input-${capitulo.chapterId}`}
                      style={{
                        fontWeight: "700",
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      value={name}
                      placeholder={i18n.t("Introduce el nombre del capítulo")}
                      autoComplete="off"
                      disabled={
                        projectInfo.status === "CLOSED" ||
                        version ||
                        certificaciones
                          ? true
                          : user
                            ? freeTrialExpired ||
                              user["custom:role"] === "WORKER"
                              ? true
                              : false
                            : true
                      }
                    ></input>
                  </Box>

                  <Box
                    ref={refDivPrecio}
                    display="flex"
                    alignItems="center"
                    style={{
                      marginLeft: "auto",
                      gap: "8px",
                      flexShrink: 0,
                      marginRight: priceWidth + "%",
                    }}
                  >
                    {capitulo.warning == true ? (
                      <ReportProblemOutlinedIcon style={{ color: "#BF2929" }} />
                    ) : null}

                    {projectInfo.status === "CLOSED" ||
                    version ||
                    certificaciones ||
                    hasSelection ? null : user ? (
                      user.freeTrialExpired ||
                      user["custom:role"] === "WORKER" ? null : (
                        <Box
                          className="detallesCap"
                          style={{ minWidth: "42px" }}
                        >
                          <Box
                            style={{
                              backgroundColor: "transparent",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            {lengthSubCap != capitulo.position + 1 && (
                              <img
                                src={ArrowDownIcon}
                                onClick={e => {
                                  e.stopPropagation()
                                  moveChaptersWithArrows(
                                    projectId,
                                    capitulo,
                                    "down",
                                  )
                                }}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginTop: "2px",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                            {indice > 0 && (
                              <img
                                src={ArrowUpIcon}
                                onClick={e => {
                                  e.stopPropagation()
                                  moveChaptersWithArrows(
                                    projectId,
                                    capitulo,
                                    "up",
                                  )
                                }}
                                style={{
                                  width: "13px",
                                  height: "13px",
                                  marginTop: "2px",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      )
                    ) : null}

                    {preferencias.precioCoste && (
                      <div
                        style={{
                          minWidth: "170px",
                          fontFamily: "Helvetica",
                          fontWeight: "700",
                          width: "fit-content",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          backgroundColor: "#616161",
                          color: "white",
                          borderColor: "#616161",
                          whiteSpace: "nowrap",
                        }}
                        id="precioTotal"
                      >
                        {getCertPrevious()}
                      </div>
                    )}
                    {preferencias.costReal && (
                      <div
                        name="costReal"
                        style={{
                          fontFamily: "Helvetica",
                          fontWeight: "700",
                          width: "fit-content",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          backgroundColor: "#414141",
                          color: "white",
                          borderColor: "#414141",
                          whiteSpace: "nowrap",
                        }}
                        id="precioTotal"
                      >
                        Coste Real {getChapterProperty("costReal")}
                      </div>
                    )}
                    {(preferencias.descuento || preferencias.clientPrice) && (
                      <div
                        id="precioTotal"
                        style={{
                          fontWeight: "700",
                          backgroundColor: "white",
                          color: "#414141",
                          border: "1px solid #414141",
                          fontFamily: "Helvetica",
                          width: "fit-content",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {getCertCurrent()}
                      </div>
                    )}
                  </Box>
                </Box>
              </div>
            </div>

            <div
              style={{
                display: render ? "block" : "none",
                marginLeft: "8px",
                width: adjustWidth == true ? "98.8%" : "98.8%",
                backgroundColor:
                  capitulo.parentId == "root" ? "#CCD8FC6B" : "white",
                border: capitulo.parentId == "root" ? "" : "1px solid #F5F5F5",
                boxShadow: "0px 6px 6px rgba(0, 0, 0, 0.08)",
                borderLeft: adjustWidth == true ? "6px solid #93AEFF" : "",
              }}
            >
              {render ? (
                partidasToRender.length > 0 ? (
                  <>
                    <TablaPartida
                      certificaciones={certificaciones}
                      numeroIndex={numeroIndex}
                      openModalCreatePartida={openModalCreatePartida}
                      setOpenModalCreatePartida={(isOpen, chapterId) => {
                        setOpenModalCreatePartida(isOpen, chapterId)
                      }}
                      capitulo={capitulo}
                      partidasToRender={partidasToRender}
                      budgetSearchFilterActive={!!budgetSearchTrimmed}
                      soyFinal={soyFinal}
                      desplazamiento={desplazamiento + 60}
                      projectInfo={projectInfo}
                      contadorActualizaciones={contadorActualizaciones}
                      setContadorActualizaciones={setContadorActualizaciones}
                      alinearPrecio={alinearPrecio}
                      ocultoFinal={ocultoFinal}
                      isChecked={isChecked}
                      setIsChecked={setIsChecked}
                      version={version}
                    />
                    <div
                      id=""
                      className={numeroClases}
                      style={{
                        paddingLeft: pixelesDesp2,
                        marginLeft: "0px",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "0px",
                          marginLeft: "0px",
                        }}
                      >
                        <div style={{ minWidth: "30px" }}></div>
                        <div> </div>
                        <div className="tdCapitulo" style={{ zIndex: "2" }}>
                          <div
                            className="NombreAlign"
                            onClick={() => {
                              freeTrialExpired
                                ? openFreeTrialExpire()
                                : setOpenMovePartsToSubchapter(true)
                            }}
                            data-amplify-analytics-on="click"
                            data-amplify-analytics-name="ChapterCreated"
                            data-amplify-analytics-attrs=""
                          >
                            <button
                              className="nuevoBotonCrear4"
                              style={{
                                marginTop: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {i18n.t("Mover partidas a subcapítulo")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (!capitulo.subcapitulos ||
                    capitulo.subcapitulos.length === 0) &&
                  (capitulo.partidas || []).length === 0 ? (
                  projectInfo.status === "CLOSED" ||
                  version ||
                  certificaciones ? null : user ? (
                    user.freeTrialExpired ||
                    user["custom:role"] === "WORKER" ? null : (
                      <div
                        id=""
                        className={numeroClases}
                        style={{
                          paddingLeft: "20px",
                          marginLeft: "0px",
                          height: "60px",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "0px",
                            marginLeft: "0px",
                            height: "60px",
                          }}
                        >
                          <div style={{ minWidth: "30px" }}></div>
                          <div> </div>
                          <div className="tdCapitulo" style={{ zIndex: "2" }}>
                            <EmptyChapterActions
                              chapterId={capitulo.chapterId}
                              onCreatePart={createPar1}
                              testId={`budget-chapter-add-partida-button-${capitulo.chapterId}`}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  ) : null
                ) : null
              ) : null}
              {render ? (
                subcapitulosToRender.length > 0 ? (
                  subcapitulosToRender.map((elemento, index) => (
                    <NewCapitulo
                      certificaciones={certificaciones}
                      imTemplate={imTemplate}
                      key={`from_NewCapitulo_${elemento.chapterId ?? index}`}
                      soyFinal={soyFinal}
                      numeroIndex={numeroIndex + "." + (index + 1)}
                      indice={index}
                      capitulo={elemento}
                      desplazamiento={desplazamiento + 30}
                      numeroClases={numeroClases + 1}
                      lengthSubCap={subcapitulosToRender.length}
                      soyMargen={false}
                      projectInfo={projectInfo}
                      modificado={modificado}
                      setClose={setClose}
                      modificarMargen={modificarMargen}
                      setModificarMargen={setModificarMargen}
                      ocultoFinal={ocultoFinal}
                      setOcultoFinal={setOcultoFinal}
                      isChecked={isChecked}
                      setIsChecked={setIsChecked}
                      adjustWidth={capitulo.parentId == "root" ? true : false}
                      priceWidth={priceWidth + 0.5}
                      version={version}
                      isChecked2={isChecked2}
                      setIsChecked2={setIsChecked2}
                      budgetSearchQuery={budgetSearchQuery}
                      openModalCreatePartida={openModalCreatePartida}
                      setOpenModalCreatePartida={setOpenModalCreatePartida}
                    />
                  ))
                ) : budgetSearchTrimmed &&
                  capitulo.subcapitulos &&
                  capitulo.subcapitulos.length > 0 &&
                  subcapitulosToRender.length ===
                    0 ? null : capitulo.partidas == null ||
                  capitulo.partidas.length == 0 ? (
                  projectInfo.status === "CLOSED" ||
                  version ||
                  certificaciones ? null : user ? (
                    user.freeTrialExpired ||
                    user["custom:role"] === "WORKER" ? null : (
                      <div
                        id=""
                        className={numeroClases}
                        style={{
                          paddingLeft: "20px",
                          marginLeft: "0px",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "0px",
                            marginLeft: "0px",
                          }}
                        >
                          <div style={{ minWidth: "30px" }}></div>
                          <div> </div>
                          <div className="tdCapitulo" style={{ zIndex: "2" }}>
                            <div
                              className="NombreAlign"
                              onClick={() => {
                                freeTrialExpired
                                  ? openFreeTrialExpire()
                                  : addsubCapitulo3()
                              }}
                              data-amplify-analytics-on="click"
                              data-amplify-analytics-name="ChapterCreated"
                              data-amplify-analytics-attrs=""
                            >
                              <Button
                                size="small"
                                color="secondary"
                                startIcon={<AddIcon fontSize="small" />}
                                sx={{ marginTop: "10px", marginBottom: "10px" }}
                              >
                                {i18n.t("Nuevo subcapítulo")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  ) : null
                ) : null
              ) : null}
            </div>

            {indice === lengthSubCap - 1 ? (
              soyMargen == false ? (
                projectInfo.status === "CLOSED" ||
                version ||
                certificaciones ? null : user ? (
                  user.freeTrialExpired ||
                  user["custom:role"] === "WORKER" ? null : (
                    <div
                      id=""
                      className={numeroClases}
                      style={{
                        paddingLeft: pixelesDesp2,
                        marginLeft: "-30px",
                        height: "50px",
                      }}
                    >
                      <div
                        style={{
                          marginTop: "0px",
                          marginLeft: "0px",
                          height: "50px",
                        }}
                      >
                        <div style={{ minWidth: "30px" }}></div>
                        <div> </div>
                        <div className="tdCapitulo" style={{ zIndex: "2" }}>
                          <div
                            className="NombreAlign"
                            onClick={() => {
                              freeTrialExpired
                                ? openFreeTrialExpire()
                                : addsubCapitulo2()
                            }}
                            data-amplify-analytics-on="click"
                            data-amplify-analytics-name="ChapterCreated"
                            data-amplify-analytics-attrs=""
                          >
                            <Button
                              size="small"
                              color="secondary"
                              startIcon={<AddIcon fontSize="small" />}
                              sx={{ marginTop: "10px", marginBottom: "10px" }}
                            >
                              {i18n.t("Nuevo subcapítulo")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ) : null
              ) : projectInfo.status === "CLOSED" ||
                version ||
                isBudgetClosed ||
                certificaciones ? null : user ? (
                user.freeTrialExpired ||
                user["custom:role"] === "WORKER" ? null : (
                  <div
                    id=""
                    className={numeroClases}
                    style={{
                      paddingLeft: "80px",
                      marginLeft: "-30px",
                    }}
                  >
                    <div
                      style={{
                        marginTop: "0px",
                        marginLeft: "0px",
                      }}
                    >
                      <div style={{ minWidth: "30px" }}></div>
                      <div> </div>
                      <div
                        className="tdCapitulo"
                        style={{ zIndex: "2", marginLeft: "-30px" }}
                      >
                        <div
                          className="NombreAlign"
                          onClick={() => {
                            freeTrialExpired
                              ? openFreeTrialExpire()
                              : addsubCapitulo2()
                          }}
                          data-amplify-analytics-on="click"
                          data-amplify-analytics-name="ChapterCreated"
                          data-amplify-analytics-attrs=""
                        >
                          <Button
                            size="small"
                            color="secondary"
                            startIcon={<AddIcon fontSize="small" />}
                            sx={{ marginTop: "20px", marginBottom: "20px" }}
                          >
                            {i18n.t("Nuevo subcapítulo")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              ) : null
            ) : null}
          </Fragment>
        )
      ) : null}

      {openMovePartsToSubchapter && (
        <MovePartsToSubchapterModal
          open={openMovePartsToSubchapter}
          setOpen={setOpenMovePartsToSubchapter}
          callback={() => {
            addsubCapitulo3()
            setOpenMovePartsToSubchapter(false)
          }}
        />
      )}
    </Fragment>
  )
}

NewCapitulo.propTypes = {
  capitulo: propTypes.object.isRequired,
  desplazamiento: propTypes.number.isRequired,
  CapitulosPresupuesto: propTypes.array,
  setCapitulosPresupuesto: propTypes.func,
  numeroClases: propTypes.number.isRequired,
  indice: propTypes.number.isRequired,
  numeroIndex: propTypes.any.isRequired,
  lengthSubCap: propTypes.number.isRequired,
  soyMargen: propTypes.bool,
  soyFinal: propTypes.bool,
  projectInfo: propTypes.object,
  modificado: propTypes.number,
  setClose: propTypes.func,
  modificarMargen: propTypes.bool,
  setModificarMargen: propTypes.func,
  ocultoFinal: propTypes.bool,
  setOcultoFinal: propTypes.func,
  isChecked: propTypes.any,
  setIsChecked: propTypes.func,
  adjustWidth: propTypes.bool,
  priceWidth: propTypes.any,
  status: propTypes.string,
  version: propTypes.object,
  isChecked2: propTypes.any,
  setIsChecked2: propTypes.func,
  imTemplate: propTypes.bool,
  certificaciones: propTypes.bool,
  setOpenModalCreatePartida: propTypes.func,
  openModalCreatePartida: propTypes.bool,
  budgetSearchQuery: propTypes.string,
}
export default NewCapitulo
